export default __webpack_public_path__ + "static/media/PublicSansItalic.88579f55.ttf";